import { useEffect, useRef, useState } from "react";
import {
  KardeshevCounter,
  Card,
  Rates,
  Policies,
  Overlay,
  Zoom,
} from "../../components";
import { GridStack } from "gridstack";
import { cardsData, stemCardsData } from "../../Database/database";

import classes from "./Factories.module.scss";
import "gridstack/dist/gridstack.min.css";
import "./Factories.css";

export default function FactoriesPage() {
  const [overlay, setOverlay] = useState(null);
  const gridRef = useRef(null);
  const [cards, setCards] = useState(cardsData());
  const stemGridRef = useRef(null);
  const [stemCards, setStemCards] = useState(stemCardsData());

  useEffect(() => {
    let options = {
      cellHeight: "163px",
      minRow: 1,
      float: true,
      resizable: { handles: "all" },
      columnOpts: {
        columnMax: 500, //cigarettes
        columnWidth: 300,
        layout: "none",
        acceptWidgets: ".card",
      },
    };
    const grid = GridStack.init(options, gridRef.current);
    const stemGrid = GridStack.init(options, stemGridRef.current);

    //const serializedData = [
    //{x: 0, y: 0, w: 2, h: 2},
    //{x: 2, y: 3, w: 3, content: 'item 2'},
    //{x: 1, y: 3}
    //];
    console.log(grid.save());
    //grid.load(serializedData);
    return () => {};
  }, []);

  return (
    <>
      {overlay ? (
        <Overlay value={overlay} onClick={() => setOverlay(null)} />
      ) : null}
      <div className={classes.factories}>
        <KardeshevCounter />
        <Zoom>
          <div ref={gridRef} className="grid-stack">
            <Policies onClick={(policy) => setOverlay(policy)} />
            {cards
              ? cards.map((factory, i) => (
                  <Card
                    value={factory}
                    key={i}
                    onClick={() => setOverlay(factory)}
                  />
                ))
              : null}
          </div>
          <div className={classes.stem}>{"STEM"}</div>
          <div ref={stemGridRef} className="grid-stack">
            <Rates />
            {stemCards
              ? stemCards.map((factory, i) => (
                  <Card
                    value={factory}
                    key={i}
                    onClick={() => setOverlay(factory)}
                  />
                ))
              : null}
          </div>
        </Zoom>
      </div>
    </>
  );
}
